import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { CustomerContext } from '../../../contexts/customer-context';

import Button from '../../../component-library/button';
import ButtonIcon from '../../../component-library/button-icon';
import ButtonFilter from '../../../component-library/button-filter';

const Filter = ({
	filter,
	setFilter,
	setShowFilter,
}) => {
	const {
		search: {
			dimensions: filterData,
		} = {},
	} = useContext(CustomerContext);

	const handleFilter = (sectionCode, filterCode) => {
		let newFilterArray = [];

		if (filter[sectionCode]) {
			newFilterArray = filter[sectionCode];
		}

		if (newFilterArray.includes(filterCode)) {
			newFilterArray = newFilterArray.filter(item => item !== filterCode);
		} else {
			newFilterArray.push(filterCode);
		}

		if (newFilterArray.length === 0) {
			const newFilter = filter;
			delete newFilter[sectionCode];
			setFilter({
				...newFilter,
			});
		} else {
			setFilter({
				...filter,
				[sectionCode]: newFilterArray,
			});
		}
	};

	const handleClearFilter = () => {
		setShowFilter(false);
		setFilter({});
	};

	return (
		<div className="search__filter-background" role="presentation" onClick={() => setShowFilter(false)}>
			<div className="search__filter-container" role="presentation" onClick={e => e.stopPropagation()}>
				<div className="flex-row justify-space-between align-items-flex-start">
					<h3>Filter</h3>
					<ButtonIcon
						icon="xmark"
						onClick={() => setShowFilter(false)}
						classes="search__filter-close"
					/>
				</div>
				{filterData && (
					filterData.map((section, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<div className="search__filter-group" key={index}>
							<div className="search__filter-heading">{section.name}</div>
							{section.values && (
								section.values.map((item, itemIndex) => (
									<ButtonFilter
										// eslint-disable-next-line react/no-array-index-key
										key={itemIndex}
										label={item.name}
										filter={item.code}
										isActive={
											filter[section.code] ? filter[section.code].includes(item.code) : false
										}
										onClick={() => handleFilter(section.code, item.code)}
									/>
								))
							)}
						</div>
					))
				)}
				<div className="text-right">
					<Button
						type="secondary"
						label="Clear Filters"
						onClick={() => handleClearFilter()}
					/>
				</div>
			</div>
		</div>
	);
};

export default Filter;

Filter.propTypes = {
	filter: PropTypes.shape({
		classificationIds: PropTypes.arrayOf(PropTypes.number),
	}).isRequired,
	setFilter: PropTypes.func.isRequired,
	setShowFilter: PropTypes.func.isRequired,
};
